<template>
  <div 
    class="block-race-item"
    >
    <div 
      @click="showMore()"
      v-if="!status_show_more"
      class="sp-race-item p-3 cp"
      >
      <div class="d-flex align-items-center">
        <div style="width: 25%">
          <!-- {{data.raceID}} -->
          {{data.eventName}}
        </div>
        <div class="op4 flex-1" style="width: 15%">
          {{data.location}}
        </div>
        <div style="width: 15%">
          <span class="ui-tag">
            {{data.raceLevel_str}}
          </span>
        </div>
        <div style="width: 15%">
          {{data.distance_str}}
        </div>

        <!-- start -->
        <div v-if="cfg_list_type == 'start'" style="width: 10%;" class="">
          <span class="c">{{data.price}}</span>
          ETH
        </div>
        <div v-if="cfg_list_type == 'start'" style="width: 10%;" class="">
          <span class="c">
            {{data.entry_fee * 5}}
          </span>
          ETH
        </div>
        <div v-if="cfg_list_type == 'start'" style="width: 10%;" class="text-right">
          {{data.real_horses.length}}/5
        </div>

        <!-- racing -->
        <div v-if="cfg_list_type == 'racing'" style="width: 15%;" class="">
          <span class="c">
            {{data.entry_fee * 5}}
          </span>
          ETH
        </div>
        <div v-if="cfg_list_type == 'racing'" style="width: 15%;" class="text-right">

          <!-- <div style="font-family: verdana;">
            {{fixSt(data.startedAt)}}
            <br>
            {{st_now}}
          </div> -->

          <span v-if="fixSt(data.startedAt) > st_now ">

            <uniCountdown
              :cfg_stamp="data.startedAt"
            />

          </span>

          <span v-else-if="fixSt(data.startedAt) + 2*60*1000 > st_now" class="c b">
            Live
          </span>

          <span v-else class="op4">
            Finished
          </span>
          

        </div>

        <!-- complete -->
        <div v-if="cfg_list_type == 'complete'" style="width: 15%" class="">04 Sep 2021, 14:42</div>
        <div v-if="cfg_list_type == 'complete'" style="width: 15%" class="text-right">
          <span class="c">
            {{data.price * 5 | tofixed6}}
          </span>
          ETH
        </div>

      </div>
    </div>

    <div 
      v-if="status_show_more"
      class="anim-fade-in"
      >
      <raceItemMore
        :data="data"
        :cfg_no_joined_row="cfg_list_type == 'complete' || is_live"
        :cfg_no_gate_row="cfg_list_type != 'start'"
        :cfg_show_gene_row="cfg_list_type == 'racing' && !is_live"
        :cfg_show_result_row="cfg_list_type == 'complete' || is_complete"
        :cfg_list_type="cfg_list_type"
        :cfg_is_live="is_live"
      />
      <!-- <raceItemMore
        :data="data"
        :cfg_no_joined_row="cfg_no_joined_row"
        :cfg_no_gate_row="cfg_no_gate_row"
        :cfg_show_gene_row="cfg_show_gene_row"
        :cfg_show_result_row="cfg_show_result_row"
        :cfg_list_type="cfg_list_type"
        :cfg_is_live="is_live"
      /> -->
    </div>
  </div>
</template>


<script>
import uniCountdown from '@/views/_cp_base/uni_countdown.vue'

import raceItemMore from './race_item_more.vue'
export default {
  name: 'raceItem',
  components: {
    raceItemMore,
    uniCountdown,
  },
  props: [
    'data',
    'cfg_no_joined_row',
    'cfg_no_gate_row',
    'cfg_show_gene_row',
    'cfg_show_result_row',
    'cfg_hide_more',
    'cfg_list_type',
  ],
  data() {
    return {
      status_show_more: false,
      is_countdown: false,
      is_live: false,
      is_complete: false,

      st_now: (new Date()).valueOf(),
      timer: null,
    }
  },
  computed: {},
  watch: {},
  methods: {
    showMore(){
      if(this.cfg_hide_more){
        return
      }

      this.$parent.$children.forEach(item => {
        if(item.status_show_more){
          item.status_show_more = false
        }
      })
      this.status_show_more = true
    },

    fixSt(st){
      // 对来自go语言的时间戳，抹除后3位
      if (st > 1000000000000) {
        st = parseInt(st / 1000);
      }

      // 对来自python的时间戳，补上后三位 000
      if (st < 1000000000000) {
        st = st * 1000;
      }
      return st
    },

    countdown(){
      let v = this

      v.timer = setInterval(function(){
        v.st_now = (new Date()).valueOf()

        let started_st = v.fixSt(v.data.startedAt) 
        if(started_st > v.st_now){
          v.is_countdown = true
        }
        else if(started_st + 2*60*1000 > v.st_now){
          v.is_live = true
        }
        else{
          v.is_complete = true
        }
      },1000)
    },
  },
  created() {
    let v = this

    if(v.data.status == 1){
      v.countdown()
    }
    return
  },
  //mounted() {},
  beforeDestroy() {
    let v = this
    if(v.timer){
      clearInterval(v.timer)
    }
  },
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .block-race-item{
    border-top: 1px solid rgba(120,120,120,0.2);

    .sp-race-item{
      &:hover{
        background-color: rgba(120,120,120,0.05);
      }
    }
  }
</style>